module.exports = __webpack_public_path__ + "static/thumbnail_percent-93d27b7ca22fa8c79d982a59673b93e8.png";